import React, {Component} from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { schema_to_field, showErrorInNotification } from '../../../lib/util';
import { message, Row, Input, Select, Divider, Button } from 'antd';
import Title from 'antd/lib/typography/Title';
import Form from '../../../lib/ui/form';


class TransactionActionsAddEdit extends Component {
    constructor(props) {
        super(props)

        this.state = {
          form_data: this.props.edit_data || {},
          edit_id: this.props.edit_id,
          actions:{},
          action_schema:[],
          datatype_id:this.props.datatype_id
        }

        this.list_actions = RESTExecutor.list().config({
          label: 'transaction_actions',
          params: {
            pagination: false
          }
        }).callbacks((success) => {
          let actions = {};
          success.result.rows.map((item) => {
            actions[item.id] = item
          });
          this.setState({
            actions: actions
          });
    
          if (this.props.edit_id) {
            this.setState({
              action_schema: schema_to_field(actions[this.props.edit_data.plugin_id].validation_config || {})
            })
          }
    
        })
          .connect(props.domains.plugins);


          
    this.post_actions = RESTExecutor.post().config({
      label: 'transaction_actions'
    }).callbacks((success) => {
      message.success("Transaction Action Added Successfully");
      typeof this.props.onRefreshClose === 'function' && this.props.onRefreshClose()

    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.datatype);

    this.patch_actions = RESTExecutor.patch().config({
      label: 'transaction_actions_detail',
      params: {
       
      }
    }).callbacks((success) => {
      message.success("v Modified Successfully");
      typeof this.props.onRefreshClose === 'function' && this.props.onRefreshClose()


    }, (error) => {
      showErrorInNotification(error)
        }).connect(props.domains.datatype);

    }

    stateUpdater = ({
        stateKey,
        valueKey,
        value,
        appendObj = {},
        callback
    }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        // console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    handlePostPatch = () => {
      if (this.state.edit_id) {
        this.patch_actions.config({
          params:{
            datatype_id:this.state.datatype_id,
            action_id:this.state.edit_id
          }
        }).execute(this.state.form_data)
      } else {
        this.post_actions.forId(this.state.datatype_id).execute(this.state.form_data);
      }
    }
    render() {
      const {form_data,action_schema,actions}=this.state;
        return (
            <div>
                <div style={{
          display: 'flex',
          flexDirection: 'column',
        }}>
          <Row type='flex' justify='center' style={{
            flex: 1,
            marginBottom:12
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              width: 'fit-content',
              textAlign: 'right',
              justifyContent: 'center'
            }}
            ><span style={{
              marginBottom:8
            }}>
            Name: &nbsp; <Input
              placeholder={"Name"}
              onChange={(e) => {
                this.stateUpdater({ stateKey: 'form_data', valueKey: 'action_name', value: e.target.value })
              }}
              value={form_data.action_name}
              style={{
                width: 300
              }} >
            </Input>
          </span>
          <span style={{
              marginBottom:8
            }}>Transaction Action: <Select style={{ width: 300 }}
                placeholder="Action"
                filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                showSearch
                value={form_data.plugin_id}
                onChange={(value) => {
                  this.stateUpdater({
                    stateKey: 'form_data', valueKey: 'plugin_id', value: value, callback: () => {
                      this.stateUpdater({ stateKey: 'form_data', valueKey: 'plugin_params', value: {} })
                    }
                  });
                  this.setState({
                    action_schema: schema_to_field(actions[value].validation_config || {})
                  })
                }}


              >
                {
                  Object.keys(actions).map((key, index) => {
                    let item = actions[key];
                    return <Select.Option value={item.id} key={item.id}>
                      {item.name}
                    </Select.Option>
                  })
                }

              </Select>
              </span>

              </div></Row>

            {this.state.action_schema.length > 0 ?
            <React.Fragment>
              <Divider style={{
                marginTop: 8,
                marginBottom: 8
              }} />

              <Title style={{ margin: 0 }} level={4} type='secondary'>Params</Title>
              <Form
                hideTitle
                forCreate={true}
                initialData={form_data.plugin_params || {}}
                submitted={this.state.submitted}
                onChange={(data) => {
                  console.log("Changes", data);
                  this.stateUpdater({
                    stateKey: 'form_data',
                    valueKey: 'plugin_params',
                    value: data,
                  });
                }}
                fields={this.state.action_schema}
                submitting={{}}
                errorMessage={{}}
                validationErrors={{}}
              />
            </React.Fragment>
            : null}
              
              <Row type='flex' justify='space-between' style={{
                paddingTop:12
              }}>
            <div>
              <Button type='link' style={{ color: 'red' }} onClick={() => {
                typeof this.props.onClose === 'function' && this.props.onClose()
              }}>Cancel</Button>
            </div>
            <div>
              <Button type='primary' onClick={() => {
                this.handlePostPatch()
              }}>Submit</Button>
            </div>
          </Row>
              </div>
            </div>
        );
    }

    componentDidMount(){
      this.list_actions.execute()
    }
}

export default withDomains(TransactionActionsAddEdit,"datatype","plugins");
